import { customAlphabet } from 'nanoid'

import { ProductForSource } from 'features/project-form/features/source/types'
import { FormProduct } from 'features/project-form/types'

export const generateProductId = (): number =>
  parseInt(customAlphabet('1234567890', 16)())

export const transformProducts = (
  products: FormProduct[],
): ProductForSource[] => products.map((p) => ({ id: p.uuid, name: p.name }))
